import i18n from '@/plugins/i18n';

export interface Interlocuteur {
    id: number;
    roles: string[];
    nom: string;
    prenom: string;
    telephone: string;
    email: string;
}

export function getRolesInterlocuteur() : Map<string, string> {
    return new Map<string, string>([
        ['RESPONSABLE_EXECUTION', i18n.global.t('contact.page.contact.role.exec')],
        ['RESPONSABLE_ADMINISTRATIF', i18n.global.t('contact.page.contact.role.admin')],
        ['MANAGER_ACTIVITE', i18n.global.t('contact.page.contact.role.manager')],
    ]);
}
